import React from "react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/contexts/AppContext";
import { useBrandLogo } from "@/hooks/useBrandLogo";

const BG_URL =
  "https://images.unsplash.com/photo-1671716784499-a3d26826d844?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHx3YXJtJTIwZWxlZ2FudCUyMGFic3RyYWN0JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3ODE0ODczMjV8MA&ixlib=rb-4.1.0&q=85";

export const AgeGate = () => {
  const { ageVerified, verifyAge } = useApp();
  const brand = useBrandLogo();

  if (ageVerified) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center px-4"
      data-testid="age-gate-overlay"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${BG_URL})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(10px) brightness(0.55)",
        }}
      />
      <div className="absolute inset-0 bg-black/55" />

      <div
        className="relative bg-card border border-border rounded-2xl p-8 sm:p-10 max-w-md w-full text-center bud-in shadow-[0_30px_80px_-20px_rgba(0,0,0,0.8)] ring-1 ring-primary/20"
        data-testid="age-gate-modal"
      >
        <img
          src={brand.src}
          alt={brand.label}
          className="w-28 h-28 rounded-full mx-auto mb-5 object-cover ring-2 ring-primary/40 shadow-[0_0_36px_-6px_rgba(196,182,143,0.6)]"
        />
        <h2 className="font-serif text-3xl sm:text-4xl text-foreground mb-3">
          Are you 21 or older?
        </h2>
        <p className="text-sm text-foreground/80 mb-7 leading-relaxed">
          Bud Link helps adults in legal states find cannabis strains at
          licensed dispensaries. You must be of legal age to continue.
        </p>
        <div className="flex flex-col gap-3">
          <Button
            data-testid="age-gate-yes"
            onClick={verifyAge}
            className="w-full h-12 rounded-full bg-primary text-primary-foreground hover:bg-primary/90"
          >
            Yes, I'm 21 or older
          </Button>
          <a
            data-testid="age-gate-no"
            href="https://www.google.com"
            className="text-xs uppercase tracking-[0.22em] text-muted-foreground hover:text-foreground py-2"
          >
            I'm under 21
          </a>
        </div>
        <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-6">
          By entering you agree to our Terms · v1
        </p>

        {/* Privacy note — sets the tone that we know nothing personal about the visitor. */}
        <div
          data-testid="age-gate-privacy-note"
          className="mt-5 pt-5 border-t border-border/60 text-[11px] leading-relaxed text-foreground/70 text-left"
        >
          <div className="text-[10px] uppercase tracking-[0.18em] text-emerald-300/80 mb-1.5">
            Your privacy
          </div>
          Every account on Bud Link uses an <strong className="text-foreground">alias</strong>.
          We see your city so we can show shops nearby — we do not see your real name,
          DOB, or MMJ card. Your name is never displayed anywhere on the site.
          <div className="mt-2 text-foreground/60">
            <strong className="text-foreground/80">Extra-cautious?</strong> Create a
            burner Gmail just for Bud Link and set your alias as the Google display
            name — otherwise Google shares whatever real name is on your account when
            you sign in.
          </div>
        </div>
      </div>
    </div>
  );
};
